import { SvgIcon, Text } from '@cinch-labs/design-system'
import styles from './sold-by-partner-info.module.css'
import { DynamicDrawer } from '../dynamic-drawer/dynamic-drawer'
import cx from 'classnames'

type ContentType = 'sale' | 'enquiry'

export type SoldByPartnerInfoProps = {
  callToActionText?: string
  callToActionClassName?: string
  onCallToActionClick?: () => void
  contentType?: ContentType
}

const title: Record<ContentType, string> = {
  enquiry: 'Sold by our partner Marshall Motor Group',
  sale: 'New cars sold by Marshall',
}

const copy: Record<ContentType, string[]> = {
  enquiry: [
    "We've partnered with Marshall to bring you new cars. Marshall has over 115 years of motoring know-how and is one of the UK's leading automotive retailers.",
    "Once you've found your new car through cinch, you can purchase through our checkout, and your sale will be with Marshall.",
    "Once you've completed your online purchase, they'll handle things on your collection date, when you pick up your new wheels!",
  ],
  sale: [
    "We've partnered with Marshall to bring you new cars. Marshall has over 115 years of motoring know-how and is one of the UK's leading automotive retailers.",
    "Once you've found your new car through cinch, you can purchase through our checkout, and your sale will be with Marshall.",
    "Once you've completed your online purchase, they'll handle things on your collection date, when you pick up your new wheels!",
  ],
}

/**
 * SoldByPartnerInfo is a component that displays a button with an icon and text, and a drawer with information about the sold by partner.
 * @returns A component that displays a button with an icon and text, and a drawer with information about the sold by partner.
 */
export const SoldByPartnerInfo = ({
  callToActionText = 'Sold by our partner Marshall Motor Group',
  callToActionClassName = '',
  onCallToActionClick,
  contentType = 'enquiry',
}: SoldByPartnerInfoProps) => (
  <DynamicDrawer
    ariaLabel="Information drawer about sales by our partner Marshall Motor Group"
    title={title[contentType]}
    contentNode={
      <div
        className={styles.sizingWrapper}
        data-testid="sold-by-partner-description"
      >
        {copy[contentType].map((text) => (
          <Text key={text.slice(-10)}>{text}</Text>
        ))}
      </div>
    }
    callToActionNode={
      <div
        className={cx(styles.container, callToActionClassName)}
        onClick={onCallToActionClick}
      >
        <SvgIcon name="info" size={24} color="mineShaft" />
        <span className={styles.text}>{callToActionText}</span>
      </div>
    }
  />
)
